import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Printer } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Skeleton } from '../components/ui/skeleton';
import { BillingDocument } from '../components/BillingDocument';
import { api } from '../lib/api';

// Public billing statement — /b/{token}, printable, no login
export default function PublicBillingPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/public/billing/${token}`)
      .then(({ data: d }) => setData(d))
      .catch(() => setError(true));
  }, [token]);

  if (error) {
    return (
      <div className="min-h-dvh flex items-center justify-center px-4">
        <p className="text-sm text-[hsl(var(--muted-foreground))]">This billing statement is not available.</p>
      </div>
    );
  }
  if (!data) {
    return <div className="min-h-dvh px-4 py-8 max-w-[800px] mx-auto"><Skeleton className="h-96 rounded-2xl" /></div>;
  }

  return (
    <div className="min-h-dvh bg-[hsl(var(--background))] px-4 py-6">
      <div className="max-w-[800px] mx-auto space-y-4">
        <div className="no-print flex justify-end">
          <Button data-testid="billing-print-button" variant="outline" className="h-10 rounded-xl" onClick={() => window.print()}>
            <Printer className="h-4 w-4 mr-1.5" /> Print
          </Button>
        </div>
        <BillingDocument
          bsNumber={data.bs_number}
          snapshot={data.snapshot}
          createdAt={data.created_at}
          paid={data.paid}
          orNumber={data.or_number}
        />
      </div>
    </div>
  );
}
